import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { setUserEntry } from "../../server/Customer";
import { allPolygon } from "../../server/Polygon";

import UserSighIn from "./UserSighin";
import UserLogin from "./UserLogin";
import PopUp from "../containers/PopUp";
import NewAddress from "../addressShipping/NewAddress";

import * as actionType from "../../store/action";

const UserEntry = ({ typeOfUser }) => {
  const dispatch = useDispatch();
  const [signupStep, setSignupStep] = useState(null);
  const [polygonState, setPolygonState] = useState([]);
  const [canClosePopup, setCanClosePopup] = useState(false);

  useEffect(() => {
    localStorage.removeItem("tempStation");

    const fetchPolygon = async () => {
      try {
        const response = await allPolygon();
        const polygons = response.data.map((p) => p.polygon).flat();
        setPolygonState(polygons);
      } catch (err) {
        console.error(err);
      }
    };

    fetchPolygon();
  }, []);

  const handleSignupAddressSaved = (addressData) => {
    localStorage.setItem("tempStation", JSON.stringify(addressData));

    dispatch({
      type: actionType.SET_TEMP_ADDRESS,
      payload: addressData.polygonId,
    });

    setCanClosePopup(true);
    setSignupStep("signup");
  };

  return (
    <>
      {signupStep === "signupAddress" && (
        <PopUp
          width="570px"
          close={() => setSignupStep(null)}
          canClose={canClosePopup}
        >
          <div className="new-signup-popup">
            <h2>ברוך הבא ליצירת חשבון חדש!</h2>
            <h3>רגע לפני שממשיכים, בוא נבדוק שאנו באמת מגיעים אליכם...</h3>
            <NewAddress
              polygonState={polygonState}
              onlyStreet
              pushAddress={handleSignupAddressSaved}
            />
          </div>
        </PopUp>
      )}

      {(typeOfUser === "login" || signupStep === "signup") && (
        <PopUp
          width="700px"
          close={() => {
            dispatch(setUserEntry(false));
            setSignupStep(null);
          }}
        >
          <div className="user-entry">
            <div className="user-entry-header">
              <h3>
                {typeOfUser === "login"
                  ? "כניסה לחשבון"
                  : "כמה פרטים קצרים ויוצאים לדרך"}
              </h3>

              <div className="tab-header">
                <button
                  onClick={() => {
                    dispatch(setUserEntry([true, "login"]));
                    setSignupStep(null);
                  }}
                  className={typeOfUser === "login" ? "tab login" : "tab"}
                >
                  כניסה לחשבון
                </button>

                <button
                  onClick={() => {
                    dispatch(setUserEntry([true, "signIn"]));
                    setSignupStep("signupAddress");
                  }}
                  className={typeOfUser === "signIn" ? "tab signIn" : "tab"}
                >
                  יצירת חשבון חדש
                </button>
              </div>
            </div>

            {typeOfUser === "login" ? (
              <UserLogin />
            ) : (
              <UserSighIn parentName="signIn" />
            )}
          </div>
        </PopUp>
      )}
    </>
  );
};

export default UserEntry;
